<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import BlankLayout from '@/layouts/BlankLayout.vue'
import ToastStack from '@/components/ToastStack.vue'

const route = useRoute()

const layout = computed(() => {
  // meta.layout = 'blank' для login; иначе 'default'
  const l = route.meta.layout as string | undefined
  return l === 'blank' ? BlankLayout : DefaultLayout
})
</script>

<template>
  <component :is="layout">
    <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view>
  </component>
  <ToastStack />
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.18s ease-out;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
